import FolderBreadcrumbs from './FolderBreadcrumbs';
import FolderBreadcrumbsContainer from './FolderBreadcrumbs.container';

export default FolderBreadcrumbsContainer(
  FolderBreadcrumbs
);
